import React from 'react';

const AboutPage = () => {
  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-blue-100 via-white to-red-100 overflow-x-hidden">
      <section className="w-full max-w-5xl mx-auto px-4 md:px-8 py-16">
        <h1 className="text-3xl md:text-5xl font-extrabold text-blue-900 mb-2">
          About Avalue Capital
        </h1>
        <p className="text-base md:text-lg text-red-500 font-semibold mb-6">
          Founded by Prateek Taparia
        </p>
        <p className="text-lg md:text-xl text-gray-700 mb-10 max-w-3xl">
          Turning capital into care. Finance into impact.
        </p>

        <div className="space-y-10">
          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-3">About Prateek Taparia</h2>
            <p className="text-gray-700 leading-relaxed">
              I am a finance professional with deep expertise in financial planning &amp; analysis,
              business control, and strategic costing — now channeling that foundation into one of
              the most underleveraged sectors in the economy: healthcare and broader credit
              solutions for individuals and businesses.
            </p>
            <p className="text-gray-700 leading-relaxed mt-3">
              Through Avalue Capital, I work at the intersection of disciplined financial thinking
              and the growing demand for structured capital in the healthcare space — helping
              providers, businesses, and investors unlock value where it matters most.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-3">Prateek&apos;s Background</h2>
            <p className="text-gray-700 leading-relaxed">
              With years of experience across FP&amp;A, business control, and financial strategy,
              I have built a career on translating complex financial data into clear, actionable
              decisions. That analytical rigor — combined with a sharp understanding of capital
              flows and risk — is what I now bring to Avalue Capital, where smart financing can
              directly improve outcomes for people, businesses, and the ecosystems they operate in.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-3">Mission &amp; Vision</h2>
            <p className="text-gray-700 leading-relaxed">
              My mission is simple: to make healthcare financing intelligent, accessible, and
              efficient.
            </p>
            <p className="text-gray-700 leading-relaxed mt-3">
              I believe that behind every healthcare business is a financing gap waiting to be
              bridged — and behind every gap is an opportunity for the right capital partner.
              Avalue Capital exists to be that partner: precise, reliable, and deeply aligned with
              the long-term success of those we work with.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-3">My Approach</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-1">
              <li>
                <span className="font-semibold">Analytical rigor</span> — Every opportunity is
                evaluated with discipline and depth.
              </li>
              <li>
                <span className="font-semibold">Long-term alignment</span> — I invest in
                relationships, not just transactions.
              </li>
              <li>
                <span className="font-semibold">Sector focus</span> — Healthcare isn't a side bet;
                it is the core thesis.
              </li>
              <li>
                <span className="font-semibold">Transparency</span> — Straightforward communication
                at every stage.
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-3">Let&apos;s Work Together</h2>
            <p className="text-gray-700 leading-relaxed">
              Whether you are a healthcare business seeking growth capital, an investor looking for
              curated opportunities, or a strategic partner exploring collaboration — I&apos;d
              welcome the conversation.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;